export class Microsoft365RestoreAccountAttributesInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tenantId",
            "baseName": "tenantId",
            "type": "string",
            "format": ""
        },
        {
            "name": "azureRestoreCloudAccountId",
            "baseName": "azureRestoreCloudAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "primaryDomain",
            "baseName": "primaryDomain",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365RestoreAccountAttributesInput.attributeTypeMap;
    }
    constructor() {
    }
}
